import { useApiActivateCodeByEmail } from '../../infrastructure/api/useApiActivateCodeByEmail'

export const useActivateCode = () => {
  const api = useApiActivateCodeByEmail()

  const activateCode = ({ code, email }: { code: string, email: string }) => {
    return api.mutate({ code, email })
  }

  return {
    activateCode,
    isLoading: api.isLoading,
    error: api.error,
    isSuccess: api.isSuccess,
  }
}
